import React from 'react';

export const useCommService = ({onMessage}) => {
    const socketRef = React.useRef();

    React.useEffect(() => {
        // const socket = new WebSocket("ws:localhost:3001/provider");
        // const socket = new WebSocket("ws:192.168.24.117:3001/provider");
        // const socket = new WebSocket("ws:192.168.254.1:3001/provider");
        //const socket = new WebSocket("ws:192.168.24.17:3001/provider");
        const socket = new WebSocket("wss://saiseikai.argus-bmc.net/provider");
        socketRef.current = socket;

        socket.addEventListener('message', event => {
            // console.log("MSG"); // JSON.parse(event.data)
            onMessage(event);
        });

        return () => {
            socket.close();
            // socketRef.current = null;
        }
    }, [onMessage]);

    const sendMessage = React.useCallback((message) => {
        socketRef.current?.send(JSON.stringify(message));
    }, []);

    return [ sendMessage, ];
}
